import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";

import {
  Form,
  Input,
  DatePicker,
  Button,
  Upload,
  message,
  Popconfirm,
  Modal,
  Spin,
  Col,
  Row,
  Tooltip,
  Select
} from 'antd';
import {
  MinusOutlined,
  PlusOutlined,
  SyncOutlined,
  UploadOutlined,
  DeleteOutlined,
  // EditOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import {routePath} from "../../router/paths";
import TextArea from "antd/es/input/TextArea";
// import FileEditModal from "./components/FileEditModal";
// import FileModal from "./components/FileModal";
import SignatureModal from "./SignatureModal";

import {createNewRequest, clearNewRequest, sendSignedRequests, clearSignedRequestInfo} from "../../store/newRequest/actions";
import jwtDecode from "jwt-decode";

const NewRequest = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const TOKEN = localStorage.getItem("token");
  const info = jwtDecode(JSON.parse(TOKEN).access_token);

  const [signatureInfo, setSignatureInfo] = useState([]);
  const [signatureInfo64, setSignatureInfo64] = useState([]);
  const [deathCertFiles, setDeathCertFiles] = useState([]);
  const [deathCertFiles64, setDeathCertFiles64] = useState([]);
  const [savingsBookFiles, setSavingsBookFiles ] = useState([]);
  const [savingsBookFiles64, setSavingsBookFiles64 ] = useState([]);
  const [otherNotaryDocs, setOtherNotaryDocs ] = useState([]);
  const [otherNotaryDocs64, setOtherNotaryDocs64 ] = useState([]);

  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const [newFile, setNewFile] = useState(null);
  // const [newFile64, setNewFile64]= useState(null);
  // const [showEdit, setShowEdit] = useState(false);
  const [acNum, setUcNum] = useState(null);
  // const [modalInfo, setModalInfo] = useState(false);
  // const [modalIndex, setModalIndex] = useState(false);
  // const [started, setStarted] = useState(false);
  const [accList, setAccList] = useState([]);
  const [signButtonFlag, setSignButtonFlag] = useState(true);
  const [signatureModal, setSignatureModal] = useState(false);

  const newRequest = useSelector((state) => state.newRequest);
  const signedRequestInfo = useSelector((state) => state.signedRequestInfo)
  // const user = useSelector((state) => state.user);
  const signing = useSelector((state) => state.signing);


  useEffect(()=>{

    if(!(info?.data?.idm?.isNotary)){
      props.history.push({
        pathname: routePath.HOME,
        state: {backPath: props.history.location.pathname}
      })
    }

    return ()=>{
      setSignatureModal(false);
      dispatch(clearNewRequest());
      form.resetFields();
      setUcNum(null);
      setAccList([]);
      setSignatureInfo([]);
      setSignatureInfo64([]);
      setDeathCertFiles([]);
      setDeathCertFiles64([]);
      setSavingsBookFiles([]);
      setSavingsBookFiles64([]);
      setOtherNotaryDocs([]);
      setOtherNotaryDocs64([]);
      // setIsModalVisible(false);
      // setNewFile(null);
      // setShowEdit(null);
      // setModalInfo(false);
      // setModalIndex(false);
      setSignButtonFlag(true);
      setSignatureModal(false);
      dispatch(clearSignedRequestInfo());
    }
  },[]);

  useEffect(()=>{
      if(signatureInfo){
        const result = signatureInfo.find((flag) => flag.selectedRadio === 0);
        if (result) {
          console.log("result 1", result);
          setSignButtonFlag(true);
        } else {
          setSignButtonFlag(false);
        }
      }
    }
    ,[signatureInfo]);

  useEffect(()=>{
    console.log("signatureInfo", signatureInfo);
  },[signatureInfo]);

  useEffect(()=>{
    console.log("signatureInfo64", signatureInfo64);
  },[signatureInfo64]);

  useEffect(()=>{
      if(newRequest && newRequest.payload && newRequest.payload.code === 200){
        console.log("send signButtonFlag",signButtonFlag)
        if(signButtonFlag){
          console.log("signButtonFlag",signButtonFlag)
          setSignatureModal(true)
        } else {
          props.history.push({
            pathname: routePath.REQUEST_LIST,
            state: {backPath: props.history.location.pathname} })
        }
      }
    },
    [ props.history, newRequest, clearNewRequest]);

  useEffect(()=>{
    if(signedRequestInfo && signedRequestInfo.payload && signedRequestInfo.payload.code === 200){
      props.history.push({
        pathname: routePath.REQUEST_LIST,
        state: {backPath: props.history.location.pathname}})
    }
  },[signedRequestInfo])


  useEffect(()=>{
    if(signing && signing.payload && signing.payload.code === 200){
      props.history.push({
        pathname: routePath.REQUEST_LIST,
        state: {backPath: props.history.location.pathname}})
    }
    }
    ,[signing]);

  const deleteHandler = (e, index)=>{
    e.preventDefault();

    setSignatureInfo((prev) => {
      prev.splice(index, 1);
      return [...prev]
    });
    setSignatureInfo64((prev) => {
      prev.splice(index, 1);
      return [...prev]
    });
  };

  const deleteDeathCertHandler = (e, index)=>{
    e.preventDefault();
    setDeathCertFiles((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
    setDeathCertFiles64((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
  };

  const deleteSavingsCertHandler = (e, index)=>{
    e.preventDefault();
    setSavingsBookFiles((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
    setSavingsBookFiles64((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
  };

  const deleteOtherNotaryDocsHandler = (e, index)=>{
    e.preventDefault();
    setOtherNotaryDocs((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
    setOtherNotaryDocs64((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
  };

  // const showEditModal = (e, info, index) => {
  //   e.preventDefault();
  //   setShowEdit(true);
  //   setModalInfo(info);
  //   setModalIndex(index);
  // };

  // const handleEditOk = (file, signatureFile, selectedRadio, index, file64, signatureFile64) => {
  //   setShowEdit(false);
  //   signatureInfoEdit({file, signatureFile, selectedRadio}, index);
  //   signatureInfoEdit64({file64, signatureFile64, selectedRadio}, index)
  //   setModalInfo(null);
  //   setModalIndex(null);
  // };
  //
  // const handleEditCancel = () => {
  //   setShowEdit(false);
  //   setModalInfo(null);
  //   setModalIndex(null);
  // };

  // const signatureInfoEdit =(data, index)=>{
  //   console.log('signatureInfoEdit 1',data, index );
  //   if(signatureInfo.length <= index){
  //     console.log('signatureInfoEdit 2',data, index );
  //     setSignatureInfo((prevState)=> [...prevState, data]);
  //   } else {
  //     console.log('signatureInfoEdit 3',data, index );
  //     if(signatureInfo.length !== 0){
  //       console.log('signatureInfoEdit 4',data, index );
  //       const updated = signatureInfo.map((file,i)=>{
  //         // console.log("file", file)
  //         // console.log("INDEX, I", index, i)
  //         if(index !== i){
  //           return file;
  //         } else {
  //           return data;
  //         }
  //       });
  //       // console.log('signatureInfoEdit 2',updated )
  //       setSignatureInfo([...updated]);
  //     }else{
  //       // console.log("signatureInfoEdit else")
  //       setSignatureInfo([{...data}]);
  //     }
  //   }
  // }
  //
  // const signatureInfoEdit64 =(data, index)=>{
  //   console.log('signatureInfoEdit64 1',data, index );
  //   if(signatureInfo64.length <= index){
  //     console.log('signatureInfoEdit64 2',data, index );
  //     setSignatureInfo64((prevState)=> [...prevState, data]);
  //   } else {
  //     console.log('signatureInfoEdit64 3',data, index );
  //     if(signatureInfo64.length !== 0){
  //       console.log('signatureInfoEdit64 4',data, index );
  //       const updated = signatureInfo64.map((file,i)=>{
  //         // console.log("file", file)
  //         // console.log("INDEX, I", index, i)
  //         if(index !== i){
  //           return file;
  //         } else {
  //           return data;
  //         }
  //       });
  //       // console.log('signatureInfoEdit 2',updated )
  //       setSignatureInfo64([...updated]);
  //     }else{
  //       // console.log("signatureInfoEdit else")
  //       setSignatureInfo64([{...data}]);
  //     }
  //   }
  // }

  const signatureInfoHandler = (file, signatureFile, selectedRadio, file64, signatureFile64) => {
    setSignatureInfo((prevState)=> [...prevState, {file, signatureFile, selectedRadio}]);
    setSignatureInfo64((prevState)=> [...prevState, {file64, signatureFile64, selectedRadio}]);
  };

  // const handleOk = (file, signatureFile, selectedRadio, file64, signatureFile64) => {
  //   setIsModalVisible(false);
  //   signatureInfoHandler(file, signatureFile, selectedRadio,file64, signatureFile64 );
  // };

  // const handleCancel = () => {
  //   setIsModalVisible(false);
  // };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const normFile = (e, uploadType) => {
    console.log('Upload event:', e);
    message.config({
      top: 400,
      duration: 2,
      maxCount: 3,
    });

    // notaryRequest deathCertificate savingsBook otherNotaryRequestDocs

    const types = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/tif",
      "image/tiff",
      "application/pdf",
      // "application/pkcs7-signature"
    ];
//console.log("e.file.type", e.file.type)

    // const fileExt = ()=> {
    //   const dots = e.file.name.split('.');
    //   const ext = dots[dots.length-1];
    //   console.log("ext", ext);
    //   return ext === "p7s";
    // }
    //
    // const checkType = () => {
    //   const ext = fileExt();
    //   const fileType = types.includes(e.file.type);
    //   return fileType || ext;
    // };

    const checkType = () => types.includes(e.file.type);

    if(!checkType()){
      message.error('невірний формат!');
      e.fileList.splice(-1,1);
      return e.fileList;
    } else if( e.file.size > 10485760) {
      message.error('файл перевищує допустимий розмір!');
      e.fileList.splice(-1,1);
      return e.fileList;
    } else if( e.fileList.length > 10) {
      message.error('перевищена допустима кількість файлів!');
      e.fileList.splice(10);
      return e.fileList;
    } else {
      if(uploadType === "notaryRequest"){
        console.log("HERE 1", e.file.originFileObj);
        // setNewFile(e.file.originFileObj);
        setSignatureInfo((prevState)=> [...prevState, {file: e.file.originFileObj, signatureFile: null, selectedRadio:0}]);
        getBase64(e.file.originFileObj).then((base64)=> {
          setSignatureInfo64((prevState)=> [...prevState, {file64:{
              file: base64,
              name: e.file.originFileObj.name
            }, signatureFile64:null, selectedRadio:0}]);
          }

        )
        // setIsModalVisible(true);
      }
      if (uploadType === "deathCertificate") {
        console.log("HERE 2");
        if(deathCertFiles.length < 2){
          setDeathCertFiles((prev)=> [...prev, e.file.originFileObj]);
          getBase64(e.file.originFileObj).then((base64)=> setDeathCertFiles64((prev)=> [...prev, base64]));
        }
      }
      if(uploadType === "savingsBook"){
        console.log("HERE 3")
        if(savingsBookFiles.length < 5){
          setSavingsBookFiles((prev)=> [...prev, e.file.originFileObj]);
          getBase64(e.file.originFileObj).then((base64)=> setSavingsBookFiles64((prev)=> [...prev, base64]));
        }
      }
      if(uploadType === "otherNotaryRequestDocs"){
        console.log("HERE 4")
        if(otherNotaryDocs.length < 10){
          setOtherNotaryDocs((prev)=> [...prev, e.file.originFileObj]);
          getBase64(e.file.originFileObj).then((base64)=> setOtherNotaryDocs64((prev)=> [...prev, base64]));
        }
      }


      console.log("e.fileList", e.fileList)
      return e.fileList;
    }

  };

  function handleFilename(fileName,fileType,fileIndex) {
    //функция удаляет из названия символы которые не допустимы для имени файла в windows, а так же перечень символов предоставленных заказчиком
    const nonPrintSymbols = /[\u0000-\u001F\u0080-\u009F]/g;
    const systemReservedCharacters = /([<>:"/\\|?*\u0000-\u001F]){2,}/g;
    const pathCharacters = /^\.+(\\|\/)|^\.+$/g;
    const trailingPeriods = /\.+$/g;
    const symbols =/[/\\?%*:$#|"<>«»]/g
    const dotIndex= fileName.lastIndexOf(".")
    console.log("dotIndex", dotIndex)
    const fileExtension = fileName.slice(dotIndex)
    console.log("fileExtension", fileExtension)
    fileName = fileName.replaceAll(fileExtension, '');
    fileName = fileName.normalize('NFD');
    fileName = fileName.replaceAll(pathCharacters, '');
    fileName = fileName.replaceAll(nonPrintSymbols, '');
    fileName = fileName.replaceAll(trailingPeriods, '');
    fileName = fileName.replaceAll(systemReservedCharacters, '');
    fileName = fileName.replaceAll(symbols, '');
    fileName = fileName.trim()
    console.log("fileName",fileName)
    fileName = `${fileName} ${fileType}_${fileIndex+1}`+ fileExtension
    console.log("processed fileName", fileName );
    return fileName
  }


  const handleFormResults = (filter) => {
    //signatureInfo deathCertificate otherNotaryRequestDocs savingsBook
    let filesArr = [];

   // signatureInfo && (signatureInfo.length > 0) && signatureInfo.forEach(
   //   (data) => {
   //     let file;
   //     let signFile = "";
   //     getBase64(data.file).then(
   //       (convertedToBase64) => {
   //         console.log("convertedToBase64", convertedToBase64)
   //         file = convertedToBase64;
   //       }
   //     );
   //
   //     if (data.signatureFile) {
   //       getBase64(data.signatureFile).then(
   //         (convertedToBase64) => {
   //           signFile = convertedToBase64;
   //         }
   //       );
   //     }
   //
   //     setTimeout(() => {
   //       filesArr.push({
   //         fileInfo: {
   //           fileType: "10.1.1",
   //           file: file,
   //           fileName: data.file && data.file.name,
   //           dsFile: signFile,
   //           dsFileName: data.signatureFile && data.signatureFile.name,
   //           requiredCheckDs: true
   //         }
   //       })
   //     }, 800)
   //      // return {
   //      //   fileInfo: {
   //      //     fileType: "10.1.1",
   //      //     file: file,
   //      //     fileName: data.file && data.file.name,
   //      //     dsFile: signFile,
   //      //     dsFileName: data.signatureFile && data.signatureFile.name,
   //      //     requiredCheckDs: true
   //      //   }
   //      // }
   //    }
   //  )




    filesArr.push({
      fileInfo: {
        fileType: "10.1.1",
        file: signatureInfo64[0]?.file64?.file,
        fileName: handleFilename(signatureInfo64[0]?.file64?.name,"10.1.1",0),
        dsFile: signatureInfo64[0]?.signatureFile64?.signature || null,
        dsFileName:  signatureInfo64[0]?.signatureFile64?.signatureName || null,
        requiredCheckDs: true
      }
    })

    deathCertFiles && (deathCertFiles.length > 0) && deathCertFiles.forEach(
      (data, index) => {
        filesArr.push({
          fileInfo: {
            fileType: "10.1.2",
            file: deathCertFiles64[index],
            fileName: handleFilename(data?.name,"10.1.2", index),
            dsFile: null,
            dsFileName: null,
            requiredCheckDs: false
          }
        })
      }
    )

    savingsBookFiles && (savingsBookFiles.length > 0) && savingsBookFiles.forEach(
      (data, index) => {
        filesArr.push({
          fileInfo: {
            fileType: "10.1.3",
            file: savingsBookFiles64[index],
            fileName: handleFilename(data?.name, "10.1.3",index),
            dsFile: null,
            dsFileName: null,
            requiredCheckDs: false
          }
        })
      }
    )

    otherNotaryDocs && (otherNotaryDocs.length > 0) && otherNotaryDocs.forEach(
      (data, index) => {
        filesArr.push({
          fileInfo: {
            fileType: "10.1.4",
            file: otherNotaryDocs64[index],
            fileName:  handleFilename(data?.name,"10.1.4",index),
            dsFile: null,
            dsFileName: null,
            requiredCheckDs: false
          }
        })
      }
    )

    // setTimeout(()=>{
      console.log("filesArr", filesArr)
    // }, 1300)

    // const exmpl = [{
    //   fileInfo: {
    //     fileType: "",
    //     file: "",
    //     fileName: "",
    //     dsFile: "",
    //     dsFileName: "",
    //     requiredCheckDs: false
    //   }
    // }]

    let enteredAccs = "";

    if(accList.length === 0 && acNum !== null ){
      enteredAccs = [...acNum];
    } else {
      enteredAccs = accList;
    }

    // console.log("filter.personDateBirth", filter.personDateBirth)

    const result = {
      subRequestType: filter.subRequestType,
      clientInfo:{
        certificateNumber: filter.notaryCertificateNumber,
        firstName: filter.notaryName,
        lastName: filter.notaryLastName,
        middleName: filter.notaryMiddleName,
        phoneNumber: filter.notaryPhoneNumber
      },
      notaryRequestInfo:{
        firstName: filter.personFirstName && filter.personFirstName.trim(),
        lastName: filter.personLastName && filter.personLastName.trim(),
        middleName: filter.personMiddleName && filter.personMiddleName.trim(),
        passportSerial: filter.personPassportSerial && filter.personPassportSerial.trim(),
        passportNumber: filter.personPassportNumber && filter.personPassportNumber.trim(),
        dateBirth: moment(filter.personDateBirth).format("YYYY-MM-DD"),
        ipn: filter.personIpn && filter.personIpn.trim(),
        dateDeath: moment(filter.personDateDeath).format("YYYY-MM-DD"),
      },
      accountsList: enteredAccs,
      testamentOrder: filter.testamentOrder && filter.testamentOrder.trim(),
      legalAddress: {
        indexNumber:filter.legalAddressIndexNumber && filter.legalAddressIndexNumber.trim(),
        regionName:filter.legalAddressRegionName && filter.legalAddressRegionName.trim(),
        districtName:filter.legalAddressDistrictName && filter.legalAddressDistrictName.trim(),
        localityName:filter.legalAddressCityLocalityName && filter.legalAddressCityLocalityName.trim(),
        streetName:filter.legalAddressStreetName && filter.legalAddressStreetName.trim(),
        houseNumber:filter.legalAddressHouseNumber && filter.legalAddressHouseNumber.trim(),
        sectionNumber:filter.legalAddressSectionNumber && filter.legalAddressSectionNumber.trim(),
        apartmentNumber:filter.legalAddressApartmentNumber && filter.legalAddressApartmentNumber.trim(),
        note:filter.legalAddressNote && filter.legalAddressNote.trim(),
      },
      actualAddress: {
        indexNumber: filter.actualAddressIndexNumber && filter.actualAddressIndexNumber.trim(),
        regionName: filter.actualAddressRegionName && filter.actualAddressRegionName.trim(),
        districtName: filter.actualAddressDistrictName && filter.actualAddressDistrictName.trim(),
        localityName: filter.actualAddressLocalityName && filter.actualAddressLocalityName.trim(),
        streetName: filter.actualAddressStreetName && filter.actualAddressStreetName.trim(),
        houseNumber: filter.actualAddressHouseNumber && filter.actualAddressHouseNumber.trim(),
        sectionNumber: filter.actualAddressSectionNumber && filter.actualAddressSectionNumber.trim(),
        apartmentNumber: filter.actualAddressApartmentNumber && filter.actualAddressApartmentNumber.trim(),
        note: filter.actualAddressNote && filter.actualAddressNote.trim(),
      },
      files: filesArr
    }

    console.log("result", result)

    if(!signButtonFlag){
      dispatch(sendSignedRequests(result));
    } else{
      dispatch(createNewRequest(result));
    }

    // notaryRequest deathCertificate savingsBook otherNotaryRequestDocs

    // setStarted(true)
    // setTimeout(() => {
    //   dispatch(createNewRequest(result));
    //   setStarted(false);
    // }, 850)
  };

  const onFinish = values => {
    console.log('Received values of form: ', values);
    handleFormResults(values);
    //form.resetFields();
  };

  const onReset = () => {
    form.resetFields();
  };

  const dummyRequest =({file, onSuccess})=> {
    console.log("file", file);
    let size = file.size;
    //95 mb = 99 614 720b
    console.log("size", size);
    // const checkTotalSize =()=>{
    //   let result = false;
    //   const total = signatureInfo.reduce((accumulator, currentValue)=>{
    //     console.log("accumulator", accumulator);
    //     console.log("file", currentValue);
    //
    //     let totalSize = currentValue && currentValue.file && currentValue.file.size
    //
    //     if(currentValue.signatureFile){
    //       totalSize = totalSize + (currentValue.signatureFile && currentValue.signatureFile.size)
    //       console.log("totalSize",totalSize);
    //     }
    //     return (accumulator + totalSize);
    //   }, 0)
    //
    //   if((total + size) > 99614720){
    //     console.log("PEREBOR");
    //     result = true;
    //   }
    //   console.log("total", total + size);
    //   console.log("result", result);
    //   return result;
    // }

    // if(checkTotalSize()){
    //   message.error('сукупний розмір файлів перевищує допустимий розмір у 95MB!');
    // } else if( file.size > 9437184) {
    //   message.error('файл перевищує допустимий розмір!');
    // } else if( file.size < 1) {
    //   message.error('неможливло додати пустий файл!');
    // } else if(signatureInfo && signatureInfo.length >= 10){
    //   message.error('перевищена допустима кількість файлів!');
    // } else {
    //   console.log("signatureInfo v filah", signatureInfo)
    //   // setNewFile(file)
    //   // setTimeout(
    //   //   () => {
    //   //     onSuccess("done");
    //   //     // setIsModalVisible(true);
    //   //   }, 0
    //   // );
    // }
  }

  const fake = ({file, onSuccess}) => {
    setTimeout(
      () => {
        onSuccess("done");
      }, 0
    );
  }

  const warningMessage = 'Поле є обов\'язковим!';

  const Loading = <SyncOutlined style={{ fontSize: 24 }} spin />;

  const addNewAccToList = (e)=>{
    e.preventDefault();
    // console.log("CLICk");
    acNum &&setAccList((prev)=>[...prev, acNum]);
    acNum && setUcNum(null);
  }

  const setAcc = (e)=>{
    console.log("event", e.target.value);
    setUcNum(e.target.value);
    // form.setFieldsValue({[idPersonField]: form.getFieldValue(idDuplicateField)});
  }

  const handleDeleteAcc = (e, index) => {
    e.preventDefault();
    setAccList((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
  }


  // const handleFormData = ({file, onSuccess}) => {
  //
  //   let formData = new FormData();
  //
  //   formData.append(`file`, file);
  //
  //   console.log("formData", file)
  //   dispatch(sendFormData(formData, file.name))
  //
  //   setTimeout(
  //     () => {
  //       onSuccess("done");
  //     }, 0
  //   );
  // }
  //
  // const handleBase64 = ({file, onSuccess}) => {
  //   console.log("file",file )
  //   getBase64(file).then((data)=> {
  //     console.log("data",data)
  //      return dispatch(sendBase64({file: data, name: file.name}, file.name))
  //   }
  //    )
  //   setTimeout(
  //     () => {
  //       onSuccess("done");
  //     }, 0
  //   );
  // }

  return (
    <div className="form-container">
      {/*{console.log("info.login", info.login.length)}*/}
      <Form
        name="request_form"
        onFinish={onFinish}
        className="request-form"
        form={form}
        scrollToFirstError
        initialValues={{
          notaryName: info?.data?.idm?.firstName,
          notaryMiddleName: info?.data?.idm?.middleName,
          notaryLastName: info?.data?.idm?.lastName,
          notaryCertificateNumber: info?.data?.idm?.notaryNumber,
          notaryPhoneNumber: info?.login?.length === 13 ? info?.login : info?.data?.idm?.phones[0]
        }}
      >
        <div className="subtitle"><span>Нотаріус</span></div>
        <Form.Item
          label="Прізвище"
          className="notary-last-name"
          name="notaryLastName"
          rules={
            [{
              required: true,
              message: warningMessage,
            }
            ]}
        >
          <Input className="input-size"
                 disabled={true}
          />
        </Form.Item>
        <Form.Item
          label="Ім'я"
          name="notaryName"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              // {
              //   pattern: /^[^<>#:"\/\\|?*\x00-\x1F]*$/,
              //   message: "наявність заборонених символів /\?%*:$#|<>«»",
              // }
            ]}
        >
          <Input className="input-size"
                 disabled={true}
          />
        </Form.Item>
        <Form.Item
          label="По батькові"
          name="notaryMiddleName"
          rules={
            [
              //   {
              //   required: true,
              //   message: warningMessage,
              // },
              // {
              //   pattern: /^[^<>#:"\/\\|?*\x00-\x1F]*$/,
              //   message: "наявність заборонених символів /\?%*:$#|<>«»",
              // }
            ]}
        >
          <Input className="input-size"
                 disabled={true}
          />
        </Form.Item>

        <Form.Item
          label="Номер свідоцтва"
          name="notaryCertificateNumber"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                min: 1,
                max: 6,
                pattern: /^[0-9]{1,6}$/,
                message: "Поле має містити 6 цифр",
              },
              // {
              //   pattern: /^[^<>#:"\/\\|?*\x00-\x1F]*$/,
              //   message: "наявність заборонених символів /\?%*:$#|<>«»",
              // }
            ]}
        >
          <Input className="input-size"
                 disabled={true}
          />
        </Form.Item>
        <Form.Item
          label="Номер мобільного телефону"
          name="notaryPhoneNumber"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              //   {
              //   pattern: /^\+380\d{3}\d{2}\d{2}\d{2}$/,
              //   message: 'Номер повинен бути у форматі +380XXXXXXXXX'
              // }
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input className="input-size"
                 disabled={true}
          />
        </Form.Item>

        <Form.Item
          name="testamentOrder"
          normalize={(value, prevValue, prevValues) => value.trimStart()}
          label={<div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
            <span>Необхідність надання інформації </span>
            <span> по заповідальному розпорядженню</span>
            <span></span>
          </div>}
          rules={
            [{
              max: 255,
              message: "Поле має містити не більше 255 символів",
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input.TextArea/>
        </Form.Item>


        <div className="subtitle"><span>Інформація про запит</span></div>
        <Form.Item
          label="Тип нотаріального запиту"
          name="subRequestType"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
            ]}
        >
          <Select
            options={[
              {
                value: '1',
                label: 'Запит по померлій особі',
              },
              {
                value: '2',
                label: 'Запит по безвісно відсутній особі',
              },
              {
                value: '3',
                label: 'Запит по особі зниклій безвісти за особливих обставин',
              },
            ]}
          />
        </Form.Item>

        <div className="subtitle"><span>Персональна інформація вкладника</span></div>
        <Form.Item
          label="Дата народження:"
          name="personDateBirth"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              // {
              //   pattern: /^[^<>#:"\/\\|?*\x00-\x1F]*$/,
              //   message: "наявність заборонених символів /\?%*:$#|<>«»",
              // }
            ]}
        >
          <DatePicker placeholder="РРРР-ММ-ДД"/>
        </Form.Item>

        <Form.Item
          name="personDateDeath"
          label={<div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", marginTop: "0.5rem"}}>
            <span>Дата набуття вкладником </span>
            <span> статусу (померлий/БВО/ОЗБОО)</span>
            <span></span>
          </div>}
          rules={
            [{
              required: true,
              message: warningMessage,
            }]}
        >
          <DatePicker placeholder="РРРР-ММ-ДД"/>
        </Form.Item>

        <Form.Item
          name="personLastName"
          label="Прізвище клієнта"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="personFirstName"
          label="Ім'я клієнта"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="personMiddleName"
          label="По батькові"
          rules={
            [
            //   {
            //   required: true,
            //   message: warningMessage,
            // },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          {/*<Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>*/}
          <Input/>
        </Form.Item>

        <Form.Item
          name="personPassportSerial"
          label="Серія паспорту"
          rules={
            [{
              min: 2,
              max: 2,
              pattern: /^[АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯабвгґдеєжзиіїйклмнопрстуфхцчшщьюя]{2}$/,
              message: "Поле має містити 2 літери українського алфавіту",
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="personPassportNumber"
          label="Номер паспорту/ID паспорту"
          rules={
            [{
              min: 6,
              max: 9,
              message: "Поле має містити не меньше 6 і не більше 9 символів",
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}

        >
          <Input/>
        </Form.Item>
        <Form.Item
          name="accNum"
          label={<div>
            Номер рахунку/всі рахунки
            <Tooltip placement="top"
                     title="Для того, щоб додати рахунок, необхідно після введення номеру рахунку натиснути на зелену кнопку 'Додати рахунок' розташовану спарва від поля введення. Введення наступнупного рахунку необхідно виконувати після додавання попереднього">
              <InfoCircleOutlined style={{fontSize: "1rem", marginLeft: "0.1rem"}}/>
            </Tooltip>
          </div>}
          rules={
            [
              // {
              //   required: true,
              //   message: warningMessage,
              //
              // },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <div className="add-button-container">
            <Input value={acNum} onChange={setAcc} style={{width: "100%"}}/>
            <Tooltip placement="right" title="Додати рахунок">
              <button className="datas-btn-green btn-download" style={{marginLeft: "5px", cursor: "pointer"}}
                      onClick={(e) => addNewAccToList(e)}><PlusOutlined/></button>
            </Tooltip>
          </div>
        </Form.Item>
        <div style={{padding: 0, marginLeft:"14,75rem" }}
             className="ant-col ant-form-item-control">{
          accList && accList.map((acc, index) =>
            <div key={index} style={{listStyle: "none", display: "flex", marginLeft: "14.75rem"}}>
              <Input disabled value={acc} style={{marginRight: "0.2rem"}}/>
              <Tooltip placement="right" title="Видалити рахунок">
                <button className="datas-btn-red btn-download-red" style={{cursor: "pointer"}}
                        onClick={(e) => handleDeleteAcc(e, index)}><MinusOutlined/></button>
              </Tooltip>
            </div>)
        }
        </div>
        {/*<Row>*/}
        {/*  <Col span={24}>*/}
        {/*    <div className="ant-row ant-form-item">*/}
        {/*      <div className="ant-col ant-col ant-form-item-label">*/}
        {/*        <label>*/}
        {/*          Номер рахунку/всі рахунки*/}
        {/*          <Tooltip placement="top"*/}
        {/*                   title="Для того, щоб додати рахунок, необхідно після введення номеру рахунку натиснути на зелену кнопку 'Додати рахунок' розташовану спарва від поля введення. Введення наступнупного рахунку необхідно виконувати після додавання попереднього">*/}
        {/*            <InfoCircleOutlined style={{fontSize: "1rem", marginLeft: "0.1rem"}}/>*/}
        {/*          </Tooltip>*/}
        {/*        </label>*/}
        {/*      </div>*/}
        {/*      <div className="ant-col ant-form-item-control">*/}
        {/*        <div className="add-button-container">*/}
        {/*          <Input value={acNum} onChange={setAcc} style={{width: "100%"}}/>*/}
        {/*          <Tooltip placement="right" title="Додати рахунок">*/}
        {/*            <button className="datas-btn-green btn-download" style={{marginLeft: "5px", cursor: "pointer"}}*/}
        {/*                    onClick={(e) => addNewAccToList(e)}><PlusOutlined/></button>*/}
        {/*          </Tooltip>*/}
        {/*        </div>*/}

        {/*        <div style={{padding: 0}}*/}
        {/*             className="ant-col ant-form-item-control">{*/}
        {/*          accList && accList.map((acc, index) =>*/}
        {/*            <div key={index} style={{listStyle: "none", display: "flex"}}>*/}
        {/*              <Input disabled value={acc} style={{marginRight: "0.2rem"}}/>*/}
        {/*              <Tooltip placement="right" title="Видалити рахунок">*/}
        {/*                <button className="datas-btn-red btn-download-red" style={{cursor: "pointer"}}*/}
        {/*                        onClick={(e) => handleDeleteAcc(e, index)}><MinusOutlined/></button>*/}
        {/*              </Tooltip>*/}
        {/*            </div>)*/}
        {/*        }*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*  </Col>*/}
        {/*</Row>*/}

        <Form.Item
          name="personIpn"
          label={<Tooltip title="Реєстраційний номер облікової картки платника податків">
            <span>РНОКПП</span>
          </Tooltip>}
          rules={
            [
              {max: 10, message: "Поле має містити не більше 10 символів"}, {
              // required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів /\?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <div className="subtitle"><span>Фактична адреса вкладника</span></div>
        <Form.Item
          name="actualAddressIndexNumber"
          label="Індекс"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="actualAddressRegionName"
          label="Область"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="actualAddressDistrictName"
          label="Район"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="actualAddressLocalityName"
          label="Населений пункт"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="actualAddressStreetName"
          label="Вул., Просп., Б-р"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="actualAddressHouseNumber"
          label="№ буд., д/в"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="actualAddressSectionNumber"
          label="№ корп., секц."
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="actualAddressApartmentNumber"
          label="№ кв., кімн., оф."
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="actualAddressNote"
          label="Примітка"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <TextArea/>
        </Form.Item>

        <div className="subtitle"><span>Юридична адреса вкладника</span></div>

        <Form.Item
          name="legalAddressIndexNumber"
          label="Індекс"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="legalAddressRegionName"
          label="Область"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="legalAddressDistrictName"
          label="Район"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="legalAddressCityLocalityName"
          label="Населений пункт"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="legalAddressStreetName"
          label="Вул., Просп., Б-р"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="legalAddressHouseNumber"
          label="№ буд., д/в"
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="legalAddressSectionNumber"
          label="№ корп., секц."
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input/>
        </Form.Item>

        <Form.Item
          name="legalAddressApartmentNumber"
          label="№ кв., кімн., оф."
          rules={
            [{
              required: true,
              message: warningMessage,
            },
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <Input placeholder="У разі відсутності інформації зазначити «Відсутнє»."/>
        </Form.Item>

        <Form.Item
          name="legalAddressNote"
          label="Примітка"
          rules={
            [
              {
                pattern: /^[^<>«»#:$%"|?*\x00-\x1F]*$/,
                message: "наявність заборонених символів ?%*:$#|<>«»",
              }
            ]}
        >
          <TextArea/>
        </Form.Item>


        <div className="subtitle"><span>Вкладення</span></div>
        <Form.Item>
          <Form.Item
            label="Електронний нотаріальний запит (pdf, jpg, jpeg, png, tif, tiff)"
            name="notaryRequest"
            rules={
              [{
                required: true,
                message: warningMessage,
              }]}
            getValueFromEvent={(e) => normFile(e, "notaryRequest")}
          >
            <Upload fileList={[]} customRequest={dummyRequest}>
              {signatureInfo && signatureInfo.length !== 1 &&
                <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли</Button>}
            </Upload>
          </Form.Item>
          <div className="ant-col ant-form-item-control cntnt">
            {(signatureInfo.length !== 0) && <div className="upl-files-container">
              <ul className="upl-list">
                {signatureInfo && signatureInfo.map((info, index) =>
                  <li className="upl-file-info" key={index}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        <div className="file-name">
                          {info && info.file && info.file.name}
                        </div>
                        {/*<div className="signature-name">*/}
                        {/*  {info && info.signatureFile && info.signatureFile.name && `Файл підпису: ${info && info.signatureFile && info.signatureFile.name}`}*/}
                        {/*</div>*/}
                      </div>
                      <div className="nr-buttons-container">
                        <Tooltip placement="right" title="Видалити файл" color="#fc5a61">
                          <Popconfirm
                            title="Ви збераєтесь видалити файл. Ви впевнені？"
                            okText="Так"
                            cancelText="Ні"
                            onConfirm={(e) => deleteHandler(e, index)}
                          >
                            <button
                              className="delete-button"
                            >
                              <DeleteOutlined/>
                            </button>
                          </Popconfirm>
                        </Tooltip>
                        {/*<Tooltip placement="right" title="Редагування" color="#DCE123">*/}
                        {/*  <button*/}
                        {/*    className="edit-button"*/}
                        {/*    onClick={(e) => showEditModal(e, info, index)}*/}
                        {/*  >*/}
                        {/*    <EditOutlined/>*/}
                        {/*  </button>*/}
                        {/*</Tooltip>*/}
                      </div>

                    </div>
                  </li>
                )}
              </ul>
            </div>}
            {/*{showEdit && <FileEditModal*/}
            {/*  dummyRequest={dummyRequest}*/}
            {/*  index={modalIndex}*/}
            {/*  info={modalInfo}*/}
            {/*  getBase64={getBase64}*/}
            {/*  signatureInfo={signatureInfo}*/}
            {/*  signatureInfo64={signatureInfo64}*/}
            {/*  visible={showEdit}*/}
            {/*  onOk={handleEditOk}*/}
            {/*  onCancel={handleEditCancel}*/}
            {/*  signatureInfoEdit={signatureInfoEdit}*/}
            {/*/>}*/}
            {/*{isModalVisible && <FileModal*/}
            {/*  dummyRequest={dummyRequest}*/}
            {/*  getBase64={getBase64}*/}
            {/*  signatureInfo={signatureInfo}*/}
            {/*  newFile={newFile}*/}
            {/*  visible={isModalVisible}*/}
            {/*  onOk={handleOk}*/}
            {/*  onCancel={handleCancel}*/}
            {/*  signatureInfoEdit={signatureInfoEdit}*/}
            {/*/>}*/}
          </div>
        </Form.Item>

        <Form.Item>
          <Form.Item
            label="Документ, що підтверджує відповідний статус по вкладнику (померлий/БВО/ОЗБОО)"
            name="deathCertificate"
            rules={
              [{
                required: true,
                message: warningMessage,
              }]}
            getValueFromEvent={(e) => normFile(e, "deathCertificate")}
          >
            <Upload fileList={[]} customRequest={fake}>
              {(deathCertFiles.length < 2) &&
                <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли</Button>}
            </Upload>
          </Form.Item>
          <div className="ant-col ant-form-item-control cntnt">
            {(deathCertFiles.length !== 0) && <div className="upl-files-container">
              <ul className="upl-list">
                {deathCertFiles && deathCertFiles.map((info, index) =>
                  <li className="upl-file-info" key={index}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                      <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        <div className="file-name">
                          {info && info.name}
                        </div>
                      </div>
                      <div className="nr-buttons-container">
                        <Tooltip placement="right" title="Видалити файл" color="#fc5a61">
                          <Popconfirm
                            title="Ви збераєтесь видалити файл. Ви впевнені？"
                            okText="Так"
                            cancelText="Ні"
                            onConfirm={(e) => deleteDeathCertHandler(e, index)}
                          >
                            <button
                              className="delete-button"
                            >
                              <DeleteOutlined/>
                            </button>
                          </Popconfirm>
                        </Tooltip>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>}
          </div>
        </Form.Item>
        <Form.Item
          label="Ощадна книжка"
          name="savingsBook"
          // rules={
          //   [{
          //     required: true,
          //     message: warningMessage,
          //   }]}
          getValueFromEvent={(e) => normFile(e, "savingsBook")}

        >
          <Upload name="logo" fileList={[]} customRequest={fake}>
            {(savingsBookFiles.length < 5) &&
              <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли</Button>}
          </Upload>
        </Form.Item>
        <div className="ant-col ant-form-item-control cntnt">
          {(savingsBookFiles.length !== 0) && <div className="upl-files-container">
            <ul className="upl-list">
              {savingsBookFiles && savingsBookFiles.map((info, index) =>
                <li className="upl-file-info" key={index}>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                      <div className="file-name">
                        {info && info.name}
                      </div>
                    </div>
                    <div className="nr-buttons-container">
                      <Tooltip placement="right" title="Видалити файл" color="#fc5a61">
                        <Popconfirm
                          title="Ви збераєтесь видалити файл. Ви впевнені？"
                          okText="Так"
                          cancelText="Ні"
                          onConfirm={(e) => deleteSavingsCertHandler(e, index)}
                        >
                          <button
                            className="delete-button"
                          >
                            <DeleteOutlined/>
                          </button>
                        </Popconfirm>
                      </Tooltip>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>}
        </div>
        <Form.Item
          label="Інший документ нотаріального запиту"
          name="otherNotaryRequestDocs"
          // rules={
          //   [{
          //     required: true,
          //     message: warningMessage,
          //   }]}
          getValueFromEvent={(e) => normFile(e, "otherNotaryRequestDocs")}
        >
          <Upload fileList={[]} customRequest={fake}>
            {(otherNotaryDocs.length < 10) &&
              <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли</Button>}
          </Upload>
        </Form.Item>
        <div className="ant-col ant-form-item-control cntnt">
          {(otherNotaryDocs.length !== 0) && <div className="upl-files-container">
            <ul className="upl-list">
              {otherNotaryDocs && otherNotaryDocs.map((info, index) =>
                <li className="upl-file-info" key={index}>
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                      <div className="file-name">
                        {info && info.name}
                      </div>
                    </div>
                    <div className="nr-buttons-container">
                      <Tooltip placement="right" title="Видалити файл" color="#fc5a61">
                        <Popconfirm
                          title="Ви збераєтесь видалити файл. Ви впевнені？"
                          okText="Так"
                          cancelText="Ні"
                          onConfirm={(e) => deleteOtherNotaryDocsHandler(e, index)}
                        >
                          <button
                            className="delete-button"
                          >
                            <DeleteOutlined/>
                          </button>
                        </Popconfirm>
                      </Tooltip>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>}
        </div>

        <div className="buttons-container">
          <Popconfirm title="Ви впевнені, що бажаєте очистити форму?" onConfirm={onReset}>
            <Button className="datas-btn datas-btn-small datas-btn-red" style={{marginRight: "2rem"}}>
              Очистити форму
            </Button>
          </Popconfirm>
          <Button
            className="datas-btn datas-btn-small datas-btn-green"
            htmlType="submit"
            disabled={newRequest.isFetching || signedRequestInfo.isFetching}
          >
            {signButtonFlag ? "Підписати" : "Надіслати запит"}
          </Button>
        </div>
      </Form>
      <SignatureModal
        visible={signatureModal}
        hideUploadModal={() => setSignatureModal(false)}
        history={props.history}
      />
      <Modal
        style={{marginTop: "250px", textAlign: "center"}}
        // visible={newRequest.isFetching === true || started}
        visible={newRequest.isFetching === true}
        footer={null}
        closable={false}
      >
        <div style={{fontSize: "19px"}}>Відбувається завантаження форми запиту <Spin style={{marginLeft: "4px"}}
                                                                                     indicator={Loading}/>
        </div>
      </Modal>

      {/*<Modal*/}
      {/*  style={{marginTop:"250px", textAlign:"center" }}*/}
      {/*  visible={ newRequest && newRequest.payload && newRequest.payload.code !== 200}*/}
      {/*  closable={true}*/}
      {/*  maskClosable={true}*/}
      {/*  footer={null}*/}
      {/*>*/}
      {/*  <div style={{display: "flex", flexDirection: "row",}}>*/}
      {/*    <ExclamationCircleOutlined style={{*/}
      {/*      fontSize: 24,*/}
      {/*      color: "#fc5a61",*/}
      {/*      borderRadius: "2px",*/}
      {/*      marginLeft: "4px",*/}
      {/*      marginRight:"5px",*/}
      {/*      marginTop:"8px"*/}
      {/*    }}/>*/}
      {/*    <p style={{marginTop:"8px", fontSize: "14px"}}>{ newRequest && newRequest.payload && newRequest.payload.message}</p>*/}
      {/*  </div>*/}
      {/*</Modal>*/}
      {/*<Upload fileList={[]} customRequest={handleFormData}>*/}
      {/*  {(deathCertFiles.length < 2) &&*/}
      {/*  <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли form data</Button>}*/}
      {/*</Upload>*/}

      {/*<Upload fileList={[]} customRequest={handleBase64}>*/}
      {/*  {(deathCertFiles.length < 2) &&*/}
      {/*  <Button className="datas-btn-green" icon={<UploadOutlined/>}>Додати файли 64</Button>}*/}
      {/*</Upload>*/}



    </div>
  );
}

export default NewRequest;